import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-workspace',
  templateUrl: './mobile-workspace.component.html',
  styleUrls: ['./mobile-workspace.component.scss']
})
export class MobileWorkspaceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
